import React, { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Header } from "./components/header";
import { Footer } from "./components/footer";

import "./detail.css";
import { BaseShelf, Content, ContentDetail, LikesData } from "./globalType";
import {
  displayDuration,
  displayNumber,
  getContentUrl,
  getHost,
  share,
} from "./utils";
import { useParams } from "react-router-dom";
import { AuthContext } from "./auth";
import { likeContent } from "./api";
import classNames from "classnames";
import CopyToClipboard from "react-copy-to-clipboard";
import {
  CategoryTopMenu,
} from "./components/topMenu";
import { TailSpin } from "react-loader-spinner";

declare var $: any;

type DetailProps = {
  baseContent: Content | null;
  goToPage: (page: string, content: Content | null) => void;
};

function Detail(props: DetailProps) {
  const { goToPage } = props;
  const authContext = useContext(AuthContext);

  const { contentId } = useParams();
  const [content, setContent] = useState<ContentDetail | null>(null);
  const [likesData, setLikesData] = useState<LikesData | null>(null);
  const [initial, setInitial] = useState<Boolean>(false);
  const [menu, setMenu] = useState<BaseShelf[]>([]);

  useEffect(() => {
    fetchDetailMenu();
    if (!initial) {
      $(".sub-BG").on("mouseleave", () => {
        $(".sub-BG").removeClass("openShare");
        $(".sub-BG").addClass("closeShare");
        // $('.closeShare').addClass('inactive')
        // setTimeout(() => {
        $(".sub-BG").fadeOut(1000);
        // }, 1000);
      });
      $(".share1-BT").on("mouseenter", () => {
        // $('.share1-BT').removeClass('inactive')
        $(".sub-BG").show();
        $(".sub-BG").removeClass("closeShare");
        $(".sub-BG").addClass("openShare");
      });

      setInitial(true);
    }
  }, []);

  useEffect(() => {
    if (contentId) {
      fetchDetailById(contentId);
    }
  }, []);

  const fetchDetailById = async (id: string) => {
    try {
      const result = await fetchDetail(id);
      setContent(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDetailMenu = async () => {
    try {
      const result = await fetchMenu();
      setMenu(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const w_device = $(window).width();
  let bgImg = content?.thumb_list?.landscape_image;
  if (w_device < 800) {
    bgImg = content?.thumb_list?.portrait_image;
  }
  if (!bgImg) {
    bgImg = "/ondemand/static/assets/images/default_landscape.jpg";
  }
  const style = {
    backgroundImage: `url('${bgImg}')`,
  };

  const likes = async (contentId: string | undefined) => {
    if (!contentId) return;
    if (likesData && likesData[contentId]) {
      setLikesData({
        ...likesData,
        [contentId]: false,
      });
      return;
    }
    const result = await likeContent(
      contentId,
      authContext?.user?.profile.access_token
    );
    if (!result) return;

    setLikesData({
      ...likesData,
      [contentId]: true,
    });
  };

  let likeCls = "";
  if (likesData && content) {
    likeCls = classNames({ active: likesData[content.id] });
  }

  const handleShareMouseLeave = useMemo(
    () => () => {
      $(".sub-BG").removeClass("openShare");
      $(".sub-BG").addClass("closeShare");
      // $('.closeShare').addClass('inactive')
      // setTimeout(() => {
      $(".sub-BG").fadeOut(1000);
    },
    []
  );

  const handleShareMouseEnter = useMemo(
    () => () => {
      $(".sub-BG").show();
      $(".sub-BG").removeClass("closeShare");
      $(".sub-BG").addClass("openShare");
    },
    []
  );

  return (
    <>
      <Header goToPage={goToPage} />

      {!content && (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <TailSpin color="#00BFFF" height={150} width={150} />
        </div>
      )}
      <CategoryTopMenu goToPage={goToPage} page={"foryou"} menu={menu} />

      {content && (
        <div className="main-BG w-100">
          <div className="main-slide">
            <div className="detail-BG" style={style}>
              <div className="g-BG"></div>
              <div className="container H-container">
                <div className="inner">
                  <div className="body-detail">
                    <div className="detail">
                      <div className="d-flex cover-BG">
                        <img
                          src={
                            content.thumb_list
                              ? content.thumb_list.poster
                              : "/ondemand/static/assets/images/default_poster.jpg"
                          }
                          alt="coverImg"
                        />
                        <div>
                          <h1>{content.title}</h1>
                          <p className="mt-3 inline-p">
                            <img
                              src="/ondemand/static/img/d-video.png"
                              alt=""
                              className="mr-2"
                            />
                            {displayDuration(content.duration)}
                            <img
                              src="/ondemand/static/img/d-play.png"
                              alt=""
                              className="ml-3 mr-2"
                            />
                            {displayNumber(content.count_views)}
                            <img
                              src="/ondemand/static/img/d-like.png"
                              alt=""
                              className="ml-3 mr-2"
                            />
                            {displayNumber(content.count_likes)}
                          </p>
                          <p className="mt-3 inline-p">
                            <span className="pink-txt web mr-2">Audio : </span>
                            <span className="web">
                              {content.audio?.join(", ")}
                            </span>
                            <span className="ml-3 pink-txt web mr-2">
                              Subtitle :{" "}
                            </span>
                            <span className="web">
                              {content.subtitle?.join(", ")}
                            </span>
                          </p>
                          <div className="button-BG">
                            <button
                              className={likeCls}
                              onClick={() => {
                                likes(content.id);
                              }}
                            >
                              <img src="/ondemand/static/img/like-l.png" alt="" />
                            </button>
                            <button
                              onMouseEnter={handleShareMouseEnter}
                              className="share1-BT web"
                            >
                              <img src="/ondemand/static/img/pop-sh.png" alt="" />
                            </button>
                            <div
                              onMouseLeave={handleShareMouseLeave}
                              className="sub-BG web"
                            >
                              <div className="sub1-BT">
                                <button
                                  onClick={() => {
                                    share(
                                      "https://www.facebook.com/sharer/sharer.php?u=",
                                      getContentUrl(content)
                                    );
                                  }}
                                >
                                  <img
                                    src="/ondemand/static/img/pop-Facebook.png"
                                    alt=""
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    share(
                                      "https://twitter.com/intent/tweet?text=",
                                      getContentUrl(content)
                                    );
                                  }}
                                >
                                  <img
                                    src="/ondemand/static/img/pop-Twitter.png"
                                    alt=""
                                  />
                                </button>
                                <CopyToClipboard text={getContentUrl(content)}>
                                  <button>
                                    <img
                                      src="/ondemand/static/img/pop-E-mail.png"
                                      alt=""
                                    />
                                  </button>
                                </CopyToClipboard>
                                <button
                                  onClick={() => {
                                    share(
                                      "https://social-plugins.line.me/lineit/share?url=",
                                      getContentUrl(content)
                                    );
                                  }}
                                >
                                  <img
                                    src="/ondemand/static/img/pop-line.png"
                                    alt=""
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="share-m-BG mobile">
                            <div>
                              <button className="share-BT">
                                <img
                                  src="/ondemand/static/img/pop-sh.png"
                                  alt=""
                                />
                              </button>
                              <div className="sub">
                                <button
                                  onClick={() => {
                                    share(
                                      "https://www.facebook.com/sharer/sharer.php?u=",
                                      getContentUrl(content)
                                    );
                                  }}
                                >
                                  <img
                                    src="/ondemand/static/img/pop-Facebook.png"
                                    alt=""
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    share(
                                      "https://twitter.com/intent/tweet?text=",
                                      getContentUrl(content)
                                    );
                                  }}
                                >
                                  <img
                                    src="/ondemand/static/img/pop-Twitter.png"
                                    alt=""
                                  />
                                </button>
                                <CopyToClipboard text={getContentUrl(content)}>
                                  <button>
                                    <img
                                      src="/ondemand/static/img/pop-E-mail.png"
                                      alt=""
                                    />
                                  </button>
                                </CopyToClipboard>

                                <button
                                  onClick={() => {
                                    share(
                                      "https://social-plugins.line.me/lineit/share?url=",
                                      getContentUrl(content)
                                    );
                                  }}
                                >
                                  <img
                                    src="/ondemand/static/img/pop-line.png"
                                    alt=""
                                  />
                                </button>
                              </div>
                            </div>
                          </div>

                          {content.director && content.director.length > 0 && (
                            <p
                              className="mobile"
                              style={{ marginTop: "16px !important" }}
                            >
                              <span className="pink-txt mr-2">Director : </span>
                              {content.director?.join(", ")}
                            </p>
                          )}

                          {content.actor && content.actor.length > 0 && (
                            <p className="mobile">
                              <span className="pink-txt mr-2">Actor : </span>
                              {content.actor?.join(", ")}
                            </p>
                          )}

                          {content.genres && content.genres.length > 0 && (
                            <p className="mobile">
                              <span className="pink-txt mr-2">Genre : </span>
                              {content.genres?.join(", ")}
                            </p>
                          )}
                        </div>
                      </div>

                      {content.director && content.director.length > 0 && (
                        <p className="web">
                          <span className="pink-txt mr-2">Director : </span>
                          {content.director?.join(", ")}
                        </p>
                      )}

                      {content.actor && content.actor.length > 0 && (
                        <p className="web">
                          <span className="pink-txt mr-2">Actor : </span>
                          {content.actor?.join(", ")}
                        </p>
                      )}

                      {content.genres && content.genres.length > 0 && (
                        <p className="web">
                          <span className="pink-txt mr-2">Genre : </span>
                          {content.genres?.join(", ")}
                        </p>
                      )}

                      <p className="detail-txt web mt-3">
                        <span className="pink-txt bold">Synopsis :</span>
                      </p>
                      <p className="detail-txt">{content.synopsis}</p>
                    </div>
                    <div className="action-BG">
                      <button
                        onClick={() => {
                          window.location.href = getContentUrl(content);
                        }}
                      >
                        <img
                          src="/ondemand/static/img/play-white-l.png"
                          alt=""
                          className="mr-3"
                        />
                        Watch now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

async function fetchDetail(id: string) {
  const host = getHost();
  return axios.get(`${host}/api/series-detail/${id}`);
}

async function fetchMenu() {
  const host = getHost();
  return axios.get(`${host}/api/series-menu`);
}

export default Detail;
